import { render } from "./FerienBetreuung.vue?vue&type=template&id=2dfbd218"
import script from "./FerienBetreuung.vue?vue&type=script&lang=js"
export * from "./FerienBetreuung.vue?vue&type=script&lang=js"

import exportComponent from "/home/soviko/htdocs/soviko.de/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__